"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var flexMaps_1 = require("../constants/flexMaps"); // TODO: Testing needed


var flexSelf = function flexSelf(props) {
  if (props === void 0) {
    props = {};
  }

  var styles = {};

  if (props) {
    if (props.flexFill) {
      styles['flex'] = '1 1 auto';
    }

    if (props.flexAlignSelf) {
      styles['align-self'] = flexMaps_1.flexItemsMap[props.flexAlignSelf];
    }

    if (props.flexOrder) {
      styles['order'] = props.flexOrder;
    }
  }

  return styles;
};

exports.default = flexSelf;